import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import {withStyles} from 'material-ui/styles/index'
import Dialog, {DialogTitle, DialogContent, DialogContentText, DialogActions} from 'material-ui/Dialog'
import Grid from '../../../common/components/Grid'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import {Link} from 'react-router-dom'
import {changePassword as text} from '../text'
import LoadingButton from '../../../common/components/LoadingButton'
import {Button} from '../../../components'

const styles = theme => ({
  tabContainer: {
    marginTop: 25,
    padding: '25px 0 35px 0',
    overflow: 'hidden',
  },
  error: {
    color: 'red',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    display: 'inline',
  },
})

class ChangePasswordDialog extends React.Component {

  render() {
    const {classes} = this.props
    return (
      <Dialog
        open={this.props.show}
        onClose={() => this.props.setOpenDialog(false)}
      >
        <form>
          <DialogTitle>{text.changePassword}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {text.body}
              <Link to="/recuperar"><span className={classes.link}>{text.iForgotMyPassword}</span></Link>
            </DialogContentText>
            <Grid container>
              <Grid item xs={12} sm={12} md={4}>
                <TextField
                  label={text.labelCurrentPassword}
                  type="password"
                  autoComplete="current-password"
                  fullWidth
                  value={this.props.currentPassword.value}
                  onChange={e => this.props.setCurrentPassword(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label={text.labelNewPassword}
                  type="password"
                  autoComplete="new-password"
                  fullWidth
                  value={this.props.newPassword.value}
                  onChange={e => this.props.setNewPassword(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label={text.labelNewPassword}
                  type="password"
                  autoComplete="new-password"
                  fullWidth
                  value={this.props.confirmPassword.value}
                  onChange={e => this.props.setConfirmPassword(e.target.value)}
                />
              </Grid>
              {
                this.props.error !== '' &&
                <Grid item xs={12}>
                  <Typography className={classes.error}>{this.props.error}</Typography>
                </Grid>
              }
            </Grid>
            <DialogActions>
              <Button onClick={() => this.props.setOpenDialog(false)}>
                {text.cancel}
              </Button>
              <LoadingButton
                color="primary"
                onClick={this.props.save}
                isLoading={this.props.isSaving}
              >
                {text.save}
              </LoadingButton>
            </DialogActions>
          </DialogContent>
        </form>
      </Dialog>
    )
  }
}

ChangePasswordDialog.propTypes = {
  show: PropTypes.bool,
  setOpenDialog: PropTypes.func,
  setCurrentPassword: PropTypes.func,
  currentPassword: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  setNewPassword: PropTypes.func,
  newPassword: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  setConfirmPassword: PropTypes.func,
  confirmPassword: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  save: PropTypes.func,
  isSaving: PropTypes.bool,
  error: PropTypes.string,
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(ChangePasswordDialog)



// WEBPACK FOOTER //
// ./src/sections/profile/components/ChangePasswordDialog.js